import { ResourceGroupAccess } from "@/components/share/ResourceGroupAccess";
import { ResourceType } from "gitpod-next-api/gitpod/v1/event_pb";
import { type FC } from "react";

type ProjectGroupAccessProps = {
    projectId: string;
    maxVisible?: number;
    className?: string;
};

export const ProjectGroupAccess: FC<ProjectGroupAccessProps> = ({ projectId, maxVisible, className }) => {
    return (
        <ResourceGroupAccess
            resourceType={ResourceType.PROJECT}
            resourceId={projectId}
            maxVisible={maxVisible}
            className={className}
            trackingPrefix="project"
        />
    );
};
